import { useQuery } from '@tanstack/react-query'

import { marketShopAPI } from '@/api/new-api'
import { MarketShopCategoryModel } from '@/models'

export type GetMarketShopCategoriesResponse = Array<MarketShopCategoryModel>

export const getMarketShopCategoriesQueryKey = () => ['useGetMarketShopCategories']

export const getMarketShopCategories = async () => {
  const response =
    await marketShopAPI.get<GetMarketShopCategoriesResponse>('/market-shop/categories')
  return response.data
}

export const useGetMarketShopCategories = () => {
  return useQuery({
    queryFn: () => getMarketShopCategories(),
    queryKey: getMarketShopCategoriesQueryKey(),
  })
}
